var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuotationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03814 0V5.83915C6.03814 5.88147 6.03814 5.92556 6.03636 5.96965C5.96855 9.18109 3.3117 11.7647 0.0428237 11.7647H0V10.4949C2.57121 10.3062 4.59462 8.42452 4.59462 5.96789H0V0H6.03814Z",
    fill: "#A12568"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 0V5.83915C14.6667 5.88147 14.6667 5.92556 14.6649 5.96965C14.5953 9.18285 11.9384 11.7665 8.67135 11.7665H8.62852V10.4967C11.1997 10.308 13.2231 8.42629 13.2231 5.96965H8.62674V0H14.6667Z",
    fill: "#A12568"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotationIcon);
export default __webpack_public_path__ + "static/media/quotation-icon.3baee660.svg";
export { ForwardRef as ReactComponent };